import React from 'react';
import styled from 'styled-components';
import SubLayout from '../components/layout/SubLayout';
import { businessMenus } from '../data/businessMenus';

const Intro = styled.p`
  font-size: 1.05rem;
  color: #555;
  line-height: 1.9;
  margin-bottom: 50px;
`;

const ServiceGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(240px, 1fr));
  gap: 20px;
  margin-bottom: 50px;
`;

const ServiceCard = styled.div`
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  padding: 30px 25px;
  background: #fff;
  transition: box-shadow 0.2s ease, border-color 0.2s ease;

  &:hover {
    box-shadow: 0 6px 20px rgba(0, 86, 179, 0.1);
    border-color: #0056b3;
  }

  .icon { font-size: 2rem; margin-bottom: 12px; }
  h4 { font-size: 1.1rem; color: #222; margin-bottom: 8px; }
  p { font-size: 0.9rem; color: #666; line-height: 1.7; }
`;

const SectionLabel = styled.h3`
  font-size: 1.3rem;
  color: #1a2a40;
  margin-bottom: 20px;
  padding-bottom: 10px;
  border-bottom: 2px solid #e0e0e0;
`;

const FeatureBox = styled.div`
  background: #f8f9fa;
  border-left: 4px solid #0056b3;
  padding: 20px 25px;
  border-radius: 0 8px 8px 0;
  margin-bottom: 15px;

  h4 { font-size: 1rem; color: #333; margin-bottom: 6px; }
  p { font-size: 0.9rem; color: #666; line-height: 1.6; }
`;

const BusinessManagement = () => {
  return (
    <SubLayout
      title="건물종합관리"
      sidebarMenus={businessMenus}
      category="사업영역"
      categoryEn="Business"
      bannerBg="/images/bg_cad.jpg"
    >
      <Intro>
        주식회사 두성시스템은 전문적인 시설 및 위생 관리 서비스를 제공합니다.
        방역·소독, 저수조 청소, 청소 용역 등 건물 관리 전반에 걸친 종합 서비스를 통해
        고객의 소중한 공간을 청결하고 안전하게 유지합니다.
      </Intro>

      <SectionLabel>주요 서비스</SectionLabel>
      <ServiceGrid>
        <ServiceCard>
          <div className="icon">🦠</div>
          <h4>방역·소독</h4>
          <p>해충 방제 및 전문 소독 서비스로 위생적인 환경을 유지합니다.</p>
        </ServiceCard>
        <ServiceCard>
          <div className="icon">💧</div>
          <h4>저수조 청소</h4>
          <p>법정 의무 저수조 청소 및 수질 검사 서비스를 제공합니다.</p>
        </ServiceCard>
        <ServiceCard>
          <div className="icon">🧹</div>
          <h4>청소 용역</h4>
          <p>건물 내·외부 청소, 특수 청소 등 전문 청소 서비스를 수행합니다.</p>
        </ServiceCard>
        <ServiceCard>
          <div className="icon">🔨</div>
          <h4>시설 유지보수</h4>
          <p>건물 내 각종 시설물 점검 및 유지보수 서비스를 제공합니다.</p>
        </ServiceCard>
      </ServiceGrid>

      <SectionLabel>주요업무</SectionLabel>
      <FeatureBox>
        <h4>원스톱 종합관리 서비스</h4>
        <p>방역, 청소, 시설물 관리까지 한 업체에서 해결하는 편리한 건물종합관리 서비스를 제공합니다.</p>
      </FeatureBox>
      <FeatureBox>
        <h4>검증된 전문 인력</h4>
        <p>전문 자격증을 보유한 인력이 직접 서비스를 제공하여 신뢰도 높은 관리를 실현합니다.</p>
      </FeatureBox>
      <FeatureBox>
        <h4>정기 관리 계약 운영</h4>
        <p>연간 정기 관리 계약을 통해 지속적이고 체계적인 건물 관리 서비스를 제공합니다.</p>
      </FeatureBox>
    </SubLayout>
  );
};

export default BusinessManagement;
